import { usePortalApi } from "../api-access/use-portal-api";
import { useMemo } from "react";
import { ProductDropdownModel } from "@rhinestone/portal-web-api";
import { Unauthorized } from "../api-access/http-status-codes";
import { QueryStatus } from "react-query";

export type UserProducts = {
  products: ProductDropdownModel[] | undefined;
  status: QueryStatus;
};

export function useUserProducts(): UserProducts {
  const { data, status } = usePortalApi(
    client => client.getOrganizationPortalProductAccessForUser(),
    ["getOrganizationPortalProductAccessForUser"],
    {
      expectedErrorStatusCodes: [Unauthorized]
    }
  );
  return useMemo(() => {
    return {
      products: data,
      status
    };
  }, [data, status]);
}
